import { IPagination } from 'app/types/common';

export interface IOrganisationFeesState {
  readonly organisationFeesById?: any;
  readonly organisationFeeIds?: string[];
  readonly hasLoaded?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasSaved?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly selectOrganisationFeeLoading?: boolean;
  readonly hasLoaded?: boolean;
  readonly showAddOrganisationFee?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationOrganisationFeeIds?: string[];
  readonly currentOrganisationFeeId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IOrganisationFeesSelector
  extends IOrganisationFeesState {
  readonly currentOrganisationFee?: any;
  readonly currentFormOrganisationFee?: any;
  readonly organisationFeesFilteredByOrganisationInSelectFormat?: any;
  readonly organisationFeesByTagAndIdInSelectFormat?: any;
  readonly organisationFeesByIdInSelectFormat?: any;
  readonly organisationFeesFilteredByCompetitionInSelectFormat?: any;
  readonly organisationFeesFilteredByIdInSelectFormat?: any;
}

export enum OrganisationFeesActionTypes {
  GET_ALL_ORGANISATION_FEES_REQUESTED = 'redux-app/organisation-fees/GET_ALL_ORGANISATION_FEES_REQUESTED',
  GET_ALL_ORGANISATION_FEES_PENDING = 'redux-app/organisation-fees/GET_ALL_ORGANISATION_FEES_PENDING',
  GET_ALL_ORGANISATION_FEES_SUCCESS = 'redux-app/organisation-fees/GET_ALL_ORGANISATION_FEES_SUCCESS',
  GET_ALL_ORGANISATION_FEES_FAIL = 'redux-app/organisation-fees/GET_ALL_ORGANISATION_FEES_FAIL',
  GET_ORGANISATION_FEE_REQUESTED = 'redux-app/organisation-fees/GET_ORGANISATION_FEE_REQUESTED',
  GET_ORGANISATION_FEE_PENDING = 'redux-app/organisation-fees/GET_ORGANISATION_FEE_PENDING',
  GET_ORGANISATION_FEE_SUCCESS = 'redux-app/organisation-fees/GET_ORGANISATION_FEE_SUCCESS',
  GET_ORGANISATION_FEE_FAIL = 'redux-app/organisation-fees/GET_ORGANISATION_FEE_FAIL',
  UPDATE_ORGANISATION_FEE_REQUESTED = 'redux-app/organisation-fees/UPDATE_ORGANISATION_FEE_REQUESTED',
  UPDATE_ORGANISATION_FEE_PENDING = 'redux-app/organisation-fees/UPDATE_ORGANISATION_FEE_PENDING',
  UPDATE_ORGANISATION_FEE_SUCCESS = 'redux-app/organisation-fees/UPDATE_ORGANISATION_FEE_SUCCESS',
  UPDATE_ORGANISATION_FEE_FAIL = 'redux-app/organisation-fees/UPDATE_ORGANISATION_FEE_FAIL',
  CREATE_ORGANISATION_FEE_REQUESTED = 'redux-app/organisation-fees/CREATE_ORGANISATION_FEE_REQUESTED',
  CREATE_ORGANISATION_FEE_PENDING = 'redux-app/organisation-fees/CREATE_ORGANISATION_FEE_PENDING',
  CREATE_ORGANISATION_FEE_SUCCESS = 'redux-app/organisation-fees/CREATE_ORGANISATION_FEE_SUCCESS',
  CREATE_ORGANISATION_FEE_FAIL = 'redux-app/organisation-fees/CREATE_ORGANISATION_FEE_FAIL',
  DELETE_ORGANISATION_FEE_REQUESTED = 'redux-app/organisation-fees/DELETE_ORGANISATION_FEE_REQUESTED',
  DELETE_ORGANISATION_FEE_PENDING = 'redux-app/organisation-fees/DELETE_ORGANISATION_FEE_PENDING',
  DELETE_ORGANISATION_FEE_SUCCESS = 'redux-app/organisation-fees/DELETE_ORGANISATION_FEE_SUCCESS',
  DELETE_ORGANISATION_FEE_FAIL = 'redux-app/organisation-fees/DELETE_ORGANISATION_FEE_FAIL',
  SELECT_ORGANISATION_FEE_REQUESTED = 'redux-app/organisation-fees/SELECT_ORGANISATION_FEE_REQUESTED',
}

export default null;
